import CategoryType from 'owa-service/lib/contract/CategoryType';
import { getCategoriesStore } from '../store/store';
import { getCategoryMetadataFromCategory } from './getCategoryMetadataFromCategory';

/**
 * Adds the passed category to the store
 * @param category
 */
export const addCategoryToStore = (category: CategoryType) => {
    const { categoriesLookup } = getCategoriesStore();
    categoriesLookup?.set(category.Name, getCategoryMetadataFromCategory(category));
};
